import React from 'react'
import { Box, Group, Text } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'

export default function LoginLegalNotice() {
  return (
    <Box
      p="lg"
      style={{
        backgroundColor: 'rgba(30, 64, 175, 0.05)',
        borderRadius: '16px',
        border: '1px solid rgba(30, 64, 175, 0.1)',
      }}
    >
      <Group gap="sm" align="flex-start" wrap="nowrap">
        <IconAlertCircle size={20} color="#3b82f6" className="mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <Text size="sm" style={{ color: '#6b7280', lineHeight: '1.6' }}>
            本服务仅限本人实名认证查询使用，不支持查询他人信息。报告用于合法合规场景，非中国人民银行征信中心出具的个人征信报告。报告内容仅供参考，不提供风险评估报告外的贷款等金融服务。如有疑问请联系客服。
          </Text>
          <Group gap="lg" mt="md">
            <Text
              size="sm"
              className="cursor-pointer"
              style={{
                color: '#3b82f6',
                fontWeight: 500,
                transition: 'color 0.2s ease',
              }}
              onClick={() => window.open('/userAgreement.html', '_blank')}
            >
              用户协议
            </Text>
            <Text
              size="sm"
              className="cursor-pointer"
              style={{
                color: '#3b82f6',
                fontWeight: 500,
                transition: 'color 0.2s ease',
              }}
              onClick={() => window.open('/privacyPolicy.html', '_blank')}
            >
              隐私政策
            </Text>
          </Group>
        </div>
      </Group>
    </Box>
  )
}
